import React from 'react';

import './CustomFormLayout.css';

class CustomFormLayout extends React.Component {
    render() {
        return <div className="custom-form-layout">{this.props.children}</div>;
    }
}

export default CustomFormLayout;



// WEBPACK FOOTER //
// ./src/modules/form/components/custom-form-layout/CustomFormLayout.jsx